import { useFiltersParam as useFiltersParamBase } from '../../../../hooks/search-params/use-filters-param';
import { CUSTOMERS_FILTER_FIELDS } from '../customers-page-utils/filter-fields-utils';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';

export function useFiltersParam() {
  return useFiltersParamBase<FilterLineType>('customerFilters', CUSTOMERS_FILTER_FIELDS);
}
